import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const infoContainerStyles = makeStyles((theme: Theme) => 
    createStyles({
        control:{
            padding: theme.spacing(4),
            backgroundColor:'#D32F2F',
            textAlign:'center',
            color: 'white',
            fontFamily:'Cormorant Garamond',
            fontSize:'25px',
            [theme.breakpoints.up('md')]: {
                width:'100%',
                padding: theme.spacing(2),
                backgroundColor:'#D32F2F',
                textAlign:'center',
                color: 'white',
                fontFamily:'Cormorant Garamond',
                fontSize:'25px',
            }
        },
        gridMaxWidth:{
            width:'100%',
        },
        storeIcon:{
            width:'81px',
            height:'81px',
            backgroundSize:'contain',
            [theme.breakpoints.down('xs')]:{
                width:'55px',
                height:'55px',
            }
        },
        imgStore:{
            width:'100%',
            height:'100%',
            borderRadius:'10px',
            backgroundSize:'cover',
        },
        socialMediaIcon:{
            width:'55px',
            height:'55px',
            marginRight:'20px',
            backgroundSize:'contain',
            [theme.breakpoints.down('xs')]:{
                width:'35px',
                height:'35px',
            }
        }
    })
);

export default infoContainerStyles;